import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { FocusableDirective } from './editable/focusable.directive';
import { EditableDirective } from './editable/editable.directive';
import { SaveButtonDirective } from './editable/save-button.directive';
import { EditableOnKeyupDirective } from './editable/editable-on-keyup.directive';

@NgModule({
    declarations: [ErrorComponent, FocusableDirective, EditableDirective, SaveButtonDirective, EditableOnKeyupDirective],
    imports: [CommonModule, RouterModule],
    providers: [],
    exports: [FocusableDirective, EditableDirective, SaveButtonDirective, EditableOnKeyupDirective]
})
export class AppCommonModule {}
